import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { prefetchStudioChunks, markStudioVisited } from '@/lib/prefetch'

// Register service worker for offline support
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // silently fail in preview/dev
    });
  });
}

// If we land directly on a studio route, mark it now so prefetch fires
if (typeof window !== 'undefined' && window.location.pathname.startsWith('/studio')) {
  markStudioVisited();
}

const root = createRoot(document.getElementById('root')!)
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Kick off background prefetching once the critical render path is done
prefetchStudioChunks();